import errorCatalog from './errorCatalog';
import { sendLogToServer } from '../../utils/log';
import { showError } from './globalShowError'; // 💥 добавь этот импорт

export const handleError = ({ code = 'UNKNOWN_ERROR', error, context = {}, showToUser }) => {
  const catalogEntry = errorCatalog[code];

  const errorData = {
    message: catalogEntry?.message || 'Произошла неизвестная ошибка',
    retry: catalogEntry?.retry || false,
    severity: catalogEntry?.severity || 'low',
  };

  sendLogToServer('error', code || error?.message, {
    ...context,
    details: error?.stack || '',
  });

  if (typeof showToUser === 'function') {
    showToUser(errorData);
  } else if (showToUser === true) {
    showError(errorData);
  }
};
